<app-button-close-dialog></app-button-close-dialog>
<h2 mat-dialog-title>Acción realizada :: <strong>{{ data.accion == accionesDialog.Agregar ? 'Crear' : data.accion ==
    accionesDialog.Eliminar ? 'Eliminar': data.accion == accionesDialog.Ver
    ? 'Ver' : 'Modificar' }} </strong></h2>

<ngx-spinner [zIndex]="100" name="spTarea" bdColor="rgba(255,255,255,0.8)" size="default" color=" var(--primary-color)"
  type="ball-atom" [fullScreen]="false">
</ngx-spinner>

<mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true" *ngIf="data.accion != accionesDialog.Ver">

  <form [formGroup]="form">
    <ng-container *ngIf="data.accion == accionesDialog.Eliminar; else formTemplate">
      ¿Esta seguro que desea eliminar el registro <b>{{data.descripcion}}</b>?
    </ng-container>

    <ng-template #formTemplate>
      <div class="row" *ngIf="data.idExpediente == undefined">
        <div class="col">
          <app-buscar-expediente *ngIf="data.accion == accionesDialog.Agregar"
            (eventEntity)="selectExpediente($event)"></app-buscar-expediente>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Titulo</mat-label>
            <input matInput type="text" maxlength="100" style="text-transform: uppercase" formControlName="Titulo" />
            <mat-error *ngIf="form.controls['Titulo'].hasError('required')">Este campo es
              <strong>requerido</strong>.</mat-error>
            <mat-error *ngIf="form.controls['Titulo'].hasError('maxlength')">Supero el largo maximo.</mat-error>
          </mat-form-field>
        </div>



        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>Fecha vencimiento</mat-label>
            <input matInput [matDatepicker]="pickerFechaVencimiento" placeholder="MM/DD/YYYY"
              formControlName="FechaVencimiento" />
            <mat-hint>DD/MM/YYYY</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="pickerFechaVencimiento"></mat-datepicker-toggle>
            <mat-datepicker #pickerFechaVencimiento></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <ngx-spinner [zIndex]="-1" name="spTipoTarea" bdColor="rgba(255,255,255,0.8)" size="small"
              color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
            <mat-label>Tipo</mat-label>
            <mat-select placeholder="Seleccione opcion" formControlName="IdTipoTarea">
              <mat-option [value]="tipoTarea.id" *ngFor="let tipoTarea of tiposTarea">
                {{ tipoTarea.descripcion }}</mat-option>
            </mat-select>
            <mat-error *ngIf="form.controls['IdTipoTarea'].hasError('required')">Este campo es
              <strong>requerido</strong>.</mat-error>
          </mat-form-field>
        </div>

        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <ngx-spinner [zIndex]="-1" name="spEstadoTarea" bdColor="rgba(255,255,255,0.8)" size="small"
              color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
            <mat-label>Estado</mat-label>
            <mat-select placeholder="Seleccione opcion" formControlName="IdEstadoTarea">
              <mat-option [value]="estadoTarea.id" *ngFor="let estadoTarea of estadosTarea">
                {{ estadoTarea.descripcion }}</mat-option>
            </mat-select>
            <mat-error *ngIf="form.controls['IdEstadoTarea'].hasError('required')">Este campo es
              <strong>requerido</strong>.</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>Fecha inicio estimada</mat-label>
            <input matInput [matDatepicker]="pickerFechaInicioEstimada" placeholder="MM/DD/YYYY"
              formControlName="FechaInicioEstimada" />
            <mat-hint>DD/MM/YYYY</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="pickerFechaInicioEstimada"></mat-datepicker-toggle>
            <mat-datepicker #pickerFechaInicioEstimada></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>Fecha inicio real</mat-label>
            <input matInput [matDatepicker]="pickerFechaInicioReal" placeholder="MM/DD/YYYY"
              formControlName="FechaInicioReal" />
            <mat-hint>DD/MM/YYYY</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="pickerFechaInicioReal"></mat-datepicker-toggle>
            <mat-datepicker #pickerFechaInicioReal></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Nivel Avance</mat-label>
            <mat-select placeholder="Seleccione opcion" formControlName="NivelAvance">
              <mat-option [value]="nivel.id" *ngFor="
                let nivel of lstNiveles;
                let i = index;
                trackBy: trackByItems
              ">
                {{ nivel.descripcion }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Prioridad</mat-label>
            <mat-select placeholder="Seleccione opcion" formControlName="Prioridad">
              <mat-option [value]="prioridad.id" *ngFor="
                let prioridad of lstPrioridades;
                let i = index;
                trackBy: trackByItems
              ">
                {{ prioridad.descripcion }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100 col-lg-12">
            <mat-label>Descripcion</mat-label>
            <textarea matInput #message name="Descripcion" formControlName="Descripcion"></textarea>
            <mat-error *ngIf="form.controls['Descripcion'].hasError('required')">Este campo es
              <strong>requerido</strong>.</mat-error>
            <mat-hint align="start">Amplie información</mat-hint>
            <mat-hint align="end">{{ message.value.length }} / 2000</mat-hint>
          </mat-form-field>
        </div>
      </div>
    </ng-template>
  </form>


</mat-dialog-content>

<mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true" *ngIf="data.accion == accionesDialog.Ver">

  <div *ngIf="data">

    <div class="row">
      <div class="col">
        <!-- Información general de la tarea -->
        <mat-card>
          <mat-card-header>
            <mat-card-title>Información General</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="property-row"><span class="property-name">Título:</span> <span class="property-value">{{
                data.item.titulo }}</span></div>
            <div class="property-row"><span class="property-name">Descripción:</span> <span class="property-value">{{
                data.item.descripcion }}</span></div>
            <div class="property-row"><span class="property-name">Observaciones:</span> <span class="property-value">{{
                data.item.observaciones }}</span></div>
            <div class="property-row"><span class="property-name">Prioridad:</span> <span class="property-value">{{
                data.item.prioridad }}</span></div>
            <div class="property-row"><span class="property-name">Nivel Avance:</span> <span class="property-value">{{
                data.item.nivelAvance }}</span></div>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="col">

        <!-- Clasificación -->
        <mat-card>
          <mat-card-header>
            <mat-card-title>Clasificación</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="property-row"><span class="property-name">Estado Tarea:</span> <span class="property-value">{{
                data.item.estadoTarea?.descripcion }}</span></div>
            <div class="property-row"><span class="property-name">Tipo Tarea:</span> <span class="property-value">{{
                data.item.tipoTarea?.descripcion }}</span></div>
            <div class="property-row"><span class="property-name">Expediente:</span> <span class="property-value">{{
                data.item.expediente?.descripcion }}</span></div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>

    <div class="row">
      <div class="col">

        <!-- Asignaciones -->
        <mat-card>
          <mat-card-header>
            <mat-card-title>Asignaciones</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="property-row"><span class="property-name">Asignado A:</span> <span class="property-value">{{
                data.item.asignadoA?.nombre }} {{ data.item.asignadoA?.apellido }}</span></div>
            <div class="property-row"><span class="property-name">Autorizado Por:</span> <span class="property-value">{{
                data.item.autorizadoPor?.nombre }} {{ data.item.autorizadoPor?.apellido }}</span></div>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="col">

        <!-- Auditoría -->
        <mat-card>
          <mat-card-header>
            <mat-card-title>Auditoría</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="property-row"><span class="property-name">Creado Por:</span> <span class="property-value">{{
                data.item.creadoPor?.nombre }} {{ data.item.creadoPor?.apellido }}</span></div>
            <div class="property-row"><span class="property-name">Modificado Por:</span> <span class="property-value">{{
                data.item.modificadoPor?.nombre }} {{ data.item.modificadoPor?.apellido }}</span></div>
            <div class="property-row"><span class="property-name">Fecha Alta:</span> <span class="property-value">{{
                data.item.fechaAlta | date:'medium' }}</span></div>
            <div class="property-row"><span class="property-name">Fecha Modificación:</span> <span
                class="property-value">{{ data.item.fechaModificacion | date:'medium' }}</span></div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>

    <div class="row">
      <div class="col">

        <!-- Fechas relevantes -->
        <mat-card>
          <mat-card-header>
            <mat-card-title>Fechas</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="property-row"><span class="property-name">Fecha Vencimiento:</span> <span
                class="property-value">{{ data.item.fechaVencimiento | date:'medium' }}</span></div>
            <div class="property-row"><span class="property-name">Fecha Inicio Estimada:</span> <span
                class="property-value">{{ data.item.fechaInicioEstimada | date:'medium' }}</span></div>
            <div class="property-row"><span class="property-name">Fecha Inicio Real:</span> <span
                class="property-value">{{ data.item.fechaInicioReal | date:'medium' }}</span></div>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="col">

        <!-- Comentarios -->
        <mat-card>
          <mat-card-header>
            <mat-card-title>Comentarios</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="property-row"><span class="property-name">Tiene Comentarios:</span> <span
                class="property-value">{{ data.item.tieneComentarios ? 'Sí' : 'No' }}</span></div>
            <div class="property-row" *ngIf="data.item.comentarios?.length">
              <div *ngFor="let c of data.item.comentarios" class="comment-item">
                <p><strong>{{ c.creadoPor?.nombre }} {{ c.creadoPor?.apellido }} ({{ c.creadoPor?.userName }})</strong>
                  - {{ c.fecha | date:'short' }}</p>
                <p>{{ c.descripcion }}</p>
                <p><em>{{ c.observaciones }}</em></p>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>

  </div>

</mat-dialog-content>


<mat-dialog-actions align="end">
  <app-button-cancel-dialog></app-button-cancel-dialog>
  <app-button-add *ngIf="data.accion == accionesDialog.Agregar" [disabled]="!form.valid"
    (click)="agregar()"></app-button-add>

  <app-button-save [disabled]="!form.valid" [isDialogClose]="true" (saveClicked)="modificar()"
    (cancelClicked)="cancelar()" *ngIf="data.accion == accionesDialog.Modificar"></app-button-save>

  <app-button-delete (click)="eliminar()" (cancelClicked)="cancelar()" *ngIf="data.accion == accionesDialog.Eliminar"
    [isDialogClose]="true"></app-button-delete>
</mat-dialog-actions>
